import { DeletionBlocker } from '../response-models/deletion-blocker.model';

/**
 * Human-readable noun for a blocker (used in "You have N …"). Matches the
 * mobile `DeletionBlocker.label` getter so the two surfaces speak the same
 * language to the user.
 */
export function deletionBlockerLabel(blocker: DeletionBlocker): string {
  switch (blocker.type) {
    case 'active_work_orders':
      return blocker.count === 1 ? 'active work order' : 'active work orders';
    case 'pending_bids':
      return blocker.count === 1 ? 'pending or accepted bid' : 'pending or accepted bids';
    case 'active_drone_assignments':
      return blocker.count === 1 ? 'active drone assignment' : 'active drone assignments';
    default:
      return blocker.type.replace(/_/g, ' ');
  }
}
